import { Action, Direction, KeyMap } from './types';
import { BrowserUtils } from '../browserutils';

const TizenKeyMap = {
  isApplicable: () => BrowserUtils.isTizen,
  keyCodes: {
    // D-pad Up
    38: Direction.UP,
    // D-pad Down
    40: Direction.DOWN,
    // D-pad Left
    37: Direction.LEFT,
    // D-pad Right
    39: Direction.RIGHT,
    // D-pad OK
    13: Action.SELECT,
    // Back
    10009: Action.BACK,
    // Play/Pause
    179: Action.PLAY_PAUSE,
    // Next/Previous
    33: Action.NEXT,
    34: Action.PREVIOUS,
  },
};

const WebOsKeyMap = {
  isApplicable: () => BrowserUtils.isWebOs,
  keyCodes: {
    // D-pad Up
    38: Direction.UP,
    // D-pad Down
    40: Direction.DOWN,
    // D-pad Left
    37: Direction.LEFT,
    // D-pad Right
    39: Direction.RIGHT,
    // D-pad OK
    13: Action.SELECT,
    // Back
    461: Action.BACK,
    // Play/Pause
    179: Action.PLAY_PAUSE,
    // Next/Previous
    33: Action.NEXT,
    34: Action.PREVIOUS,
  },
};

const PlayStationKeyMap = {
  isApplicable: () => BrowserUtils.isPlayStation,
  keyCodes: {
    // D-pad Up
    38: Direction.UP,
    // D-pad Down
    40: Direction.DOWN,
    // D-pad Left
    37: Direction.LEFT,
    // D-pad Right
    39: Direction.RIGHT,
    // Cross
    13: Action.SELECT,
    // Circle
    27: Action.BACK,
  },
};

const AndroidKeyMap = {
  isApplicable: () => BrowserUtils.isAndroid,
  keyCodes: {
    // D-pad Up
    19: Direction.UP,
    38: Direction.UP,
    // D-pad Down
    20: Direction.DOWN,
    40: Direction.DOWN,
    // D-pad Left
    21: Direction.LEFT,
    37: Direction.LEFT,
    // D-pad Right
    22: Direction.RIGHT,
    39: Direction.RIGHT,
    // D-pad Center
    23: Action.SELECT,
    13: Action.SELECT,
    66: Action.SELECT,
    // Back
    4: Action.BACK,
    27: Action.BACK,
    // Play/Pause
    179: Action.PLAY_PAUSE,
    // Next/Previous
    33: Action.NEXT,
    34: Action.PREVIOUS,
  },
};

const HisenseKeyMap = {
  isApplicable: () => BrowserUtils.isHisense,
  keyCodes: {
    // D-pad Up
    38: Direction.UP,
    // D-pad Down
    40: Direction.DOWN,
    // D-pad Left
    37: Direction.LEFT,
    // D-pad Right
    39: Direction.RIGHT,
    // OK
    13: Action.SELECT,
    // Back
    8: Action.BACK,
    // Play/Pause
    179: Action.PLAY_PAUSE,
    // Next/Previous
    33: Action.NEXT,
    34: Action.PREVIOUS,
  },
};

// Default key map used on desktops
const DefaultKeyMap = {
  // Arrow Up
  38: Direction.UP,
  // Arrow Down
  40: Direction.DOWN,
  // Arrow Left
  37: Direction.LEFT,
  // Arrow Right
  39: Direction.RIGHT,
  // Enter
  13: Action.SELECT,
  // Escape
  27: Action.BACK,
  // Play/Pause
  179: Action.PLAY_PAUSE,
  // Next/Previous
  33: Action.NEXT,
  34: Action.PREVIOUS,
};

/**
 * Returns the matching key map for the current platform.
 */
export function getKeyMapForPlatform(): KeyMap {
  const applicableKeyMap = [
    WebOsKeyMap,
    TizenKeyMap,
    PlayStationKeyMap,
    HisenseKeyMap,
    AndroidKeyMap,
  ].find(keyMap => keyMap.isApplicable());

  if (applicableKeyMap) {
    return applicableKeyMap.keyCodes;
  } else {
    return DefaultKeyMap;
  }
}
